import { formatDistanceToNow } from 'date-fns';
import { ko } from 'date-fns/locale';

/** 2024/10/15 -1   을 8자리 문자열, 시리얼번호 객체로 반환*/
export const replaceOrderUploadserno = (uploadSerno: string) => {
  const splitDash = uploadSerno.split('-');
  const ser = splitDash[1];
  const splitSlash = splitDash[0].split('/');
  const date =
    splitSlash[0].trim() + splitSlash[1].trim() + splitSlash[2].trim();

  return { date: date, serial: ser };
};

/** 문자열에서 - 제거 */
export const removeDashFromString = (dateString: string) => {
  const splitDash = dateString.split('-');
  let replaced: string = '';
  if (splitDash) {
    splitDash.forEach((item) => (replaced = replaced + item.trim()));
  }

  return replaced;
};

/** 날짜형식 문자열에서 / 및 공백 제거 */
export const removeSlashFromDateString = (dateString: string) => {
  const sliced = dateString.split('/');
  const combined = sliced.map((string) => string.trim()).join('');
  return combined;
};

/** 날짜에서 연, 월, 일 YYYY, MM, DD로 추출 */
export function getYearMonthDateFromDate(date: Date) {
  const year = date.getFullYear(); // 년도 추출 (yyyy)
  const month = date.getMonth() + 1; // 월 추출 (0~11 범위이므로 +1)
  const day = date.getDate();
  const yearString = year.toString();
  const monthString = month.toString().padStart(2, '0'); // 한 자리일 경우 앞에 '0' 추가
  const dayString = day.toString().padStart(2, '0'); // 한 자리일 경우 앞에 '0' 추가
  const dateString = yearString + monthString + dayString;
  return {
    year: year,
    month: month,
    day: day,
    yearString: yearString,
    yearStringTwoDigit: yearString.slice(2),
    monthString: monthString,
    dayString: dayString,
    dateString: dateString,
  };
}

/** 날짜형식을  YYYY-MM-DD string으로 변경 */
export function transferDateToEightStringSplitByDash(date: Date) {
  const year = date.getFullYear(); // 년도 추출 (yyyy)
  const month = date.getMonth() + 1; // 월 추출 (0~11 범위이므로 +1)
  const day = date.getDate();
  const yearString = year.toString();
  const monthString = month.toString().padStart(2, '0'); // 한 자리일 경우 앞에 '0' 추가
  const dayString = day.toString().padStart(2, '0'); // 한 자리일 경우 앞에 '0' 추가

  return `${yearString}-${monthString}-${dayString}`;
}

/** 숫자 - 천의 자리마다 , 쉼표 추가 */
export function formatCurrency(value?: number): string | null {
  if (value === undefined || value === null) {
    return null; // 데이터가 없을 때 표시할 기본값
  }
  return `${value.toLocaleString('en-US')}`;
}

/** 날짜 YYYY, MM string으로 받아 해당날짜 총 일/월 계산 */
export function getDayCountFromYearMonthString(year: string, month: string) {
  // 첫 번째 날을 설정 (ex. 2024년 10월 1일)
  const firstDayOfMonth = new Date(Number(year), Number(month) - 1, 1);

  // 다음 달의 첫 번째 날을 설정 (ex. 2024년 11월 1일)
  const firstDayOfNextMonth = new Date(Number(year), Number(month), 1);

  // 마지막 날 계산
  const lastDayOfMonth = new Date(firstDayOfNextMonth.getTime() - 1);

  // 그 차이를 밀리초로 계산한 후, 일 수로 변환
  // 두 날짜의 차이를 밀리초로 계산 후, 일 수로 변환
  const daysInMonth: number =
    (firstDayOfNextMonth.getTime() - firstDayOfMonth.getTime()) /
    (1000 * 60 * 60 * 24);

  return { daysInMonth, firstDayOfMonth, lastDayOfMonth };
}

/** 1자리, 2자리 숫자를 2자리 string으로 리턴 */
export function formatNumberToTwoDigitString(num: number): string {
  return num.toString().padStart(2, '0');
}

/** YYYYMMDD를 YYYY/MM/DD로 변경 */
export function formatEightDigitStringToSlashForm(
  string?: string
): string | null {
  if (string === undefined || string === null) {
    return null; // 데이터가 없을 때 표시할 기본값
  }
  const yyyy = string.substring(0, 4);
  const mm = string.substring(4, 6);
  const dd = string.substring(6, 8);
  const reform = yyyy + '/' + mm + '/' + dd;
  return reform;
}

/** YYYYMMDD를 YYYY-MM-DD로 변경 */
export function formatEightDigitStringToDashForm(
  string?: string
): string | null {
  if (string === undefined || string === null) {
    return null; // 데이터가 없을 때 표시할 기본값
  }
  const yyyy = string.substring(0, 4);
  const mm = string.substring(4, 6);
  const dd = string.substring(6, 8);
  const reform = yyyy + '-' + mm + '-' + dd;
  return reform;
}

/** YYYY-MM-DD를 YYYYMMDD로 변경 */
export function formatDashFormToEightDigitString(
  string?: string
): string | null {
  if (string === undefined || string === null) {
    return null; // 데이터가 없을 때 표시할 기본값
  }
  const [yyyy, mm, dd] = string.split('-');

  const reform = yyyy + mm + dd;
  return reform;
}

/** YYYYMMDD를 YY.MM.DD로 변경 */
export function formatEightDigitStringToSixDigitDot(string: string): string {
  const yy = string.substring(2, 4);
  const mm = string.substring(4, 6);
  const dd = string.substring(6, 8);
  const reform = yy + '.' + mm + '.' + dd;
  return reform;
}

/** YYYYMMDD를 각각 잘라서 반환 */
export function splitYYYYMMDD(data: string) {
  const yyyy = data.substring(0, 4);
  const mm = data.substring(4, 6);
  const dd = data.substring(6, 8);
  return { year: yyyy, month: mm, day: dd };
}

export function getDayOfWeekShort(yyyymmdd: string): string {
  // YYYYMMDD 형식 검증
  if (!/^\d{8}$/.test(yyyymmdd)) {
    throw new Error('Invalid date format. Expected YYYYMMDD.');
  }

  // 날짜 파싱
  const year = parseInt(yyyymmdd.substring(0, 4), 10);
  const month = parseInt(yyyymmdd.substring(4, 6), 10) - 1; // JavaScript 월은 0부터 시작
  const day = parseInt(yyyymmdd.substring(6, 8), 10);

  const date = new Date(year, month, day);

  // 날짜 유효성 체크
  if (isNaN(date.getTime())) {
    throw new Error('Invalid date.');
  }

  // 요일 배열
  const daysShort = ['일', '월', '화', '수', '목', '금', '토'];

  // 요일 반환
  return daysShort[date.getDay()];
}

export function getMonthStartEnd(date: Date): {
  start: string;
  end: string;
  startDash: string;
  endDash: string;
} {
  const year = date.getFullYear();
  const month = date.getMonth() + 1;

  const start = new Date(year, month - 1, 1);
  const end = new Date(year, month, 0);

  return {
    start: getYearMonthDateFromDate(start).dateString,
    end: getYearMonthDateFromDate(end).dateString,
    startDash:
      formatEightDigitStringToDashForm(
        getYearMonthDateFromDate(start).dateString
      ) || '',
    endDash:
      formatEightDigitStringToDashForm(
        getYearMonthDateFromDate(end).dateString
      ) || '',
  };
}

/** 날짜를 상대적인 형태로 변환하는 함수 ex.업데이트: 1일 전, 30분 전 */
export const getRelativeTime = (date: Date): string => {
  let distance = formatDistanceToNow(date, {
    addSuffix: true, // 상대적 시간 끝에 '전', '후' 등을 붙여줌
    includeSeconds: true, // 초 단위까지 포함
    locale: ko, // 한국어 locale 사용
  });

  // '약'과 '미만' 단어 제거
  distance = distance
    .replace(/약 /g, '') // '약' 단어 제거
    .replace(/미만 /g, '') // '미만' 단어 제거
    .replace(/일/g, '일') // '일' 그대로 유지
    .replace(/개월/g, '개월') // '개월' 그대로 유지
    .replace(/년/g, '년') // '년' 그대로 유지
    .replace(/시간/g, '시간') // '시간' 그대로 유지
    .replace(/분/g, '분') // '분' 그대로 유지
    .replace(/초/g, '초'); // '초' 그대로 유지

  return distance;
};

//string | number인 number값을 Number로 일괄변환
export function convertNumberStringToNumber(
  consumedQty: number | string
): number {
  // consumedQty가 문자열일 경우, 숫자로 변환
  if (typeof consumedQty === 'string') {
    // 숫자로 변환할 수 있는 값인지 확인 후 변환
    const parsedValue = parseFloat(consumedQty.trim());
    // NaN 방지 및 숫자형으로 변환이 안되면 기본값 0을 반환
    return isNaN(parsedValue) ? 0 : parsedValue;
  }

  // 이미 숫자일 경우 그대로 반환
  return consumedQty;
}
